import { useMemo } from 'react';
import { useLocation } from '@reach/router';
import { removeLocalesFromPath } from './language';

const useCurrentLocation = (useSearchParams = true) => {
  const location = useLocation();

  const currentLocation = useMemo(() => {
    const strippedPathname = removeLocalesFromPath(location.pathname);

    return useSearchParams ? `${strippedPathname}${location.search}` : strippedPathname;
  }, [location.pathname, location.search]);

  return currentLocation;
};

export default useCurrentLocation;
